import * as Yup from 'yup';

// Enum containing all the personas available to the sign up form
const PersonaEnum = {
    DSP: 0,
    CONTENT_CREATOR: 1,
    MATCHING_DASHBOARD: 2,
};

// The base form used across all personas
const commonForm = {
    form: {
        data: [
            { name: 'firstName', label: 'First Name', type: 'text', required: true, placeholder: '' },
            { name: 'lastName', label: 'Last Name', type: 'text', required: true, placeholder: '' },
            { name: 'email', label: 'Email', type: 'email', required: true, placeholder: '' },
            { name: 'company', label: 'Company', type: 'text', required: true, placeholder: '' },
            {
                name: 'company_size',
                label: 'Company Size',
                type: 'select',
                required: true,
                options: [
                    { value: 1, text: '1' },
                    { value: 50, text: '1-50' },
                    { value: 100, text: '50-100' },
                    { value: 500, text: '500+' },
                ],
                placeholder: 'Please select a size...',
            },
        ],
        initialValues: { firstName: '', lastName: '', email: '', company: '' },
        validationSchema: Yup.object().shape({
            firstName: Yup.string().required('First name is a required field'),
            lastName: Yup.string().required('Last name is a required field'),
            email: Yup.string().email().required('Email is a required field'),
            company: Yup.string().required('Company is a required field'),
            company_size: Yup.number().required('Company size is a required field'),
        }),
    },
    content: {
        header: 'Create Your Content Creator Account',
        helper: <strong>{`Please provide some contact details so we can create an account for you.`}</strong>,
        submitHelper: 'After submitting, you will receive an email that will enable you to create your password.',
    },
};

// Data to feed the sign up form for each persona, commonForm is customised
// slightly for each persona
const PersonaData = {
    MATCHING_DASHBOARD: {
        ...commonForm,
        content: {
            ...commonForm.content,
            helper: (
                <>
                    <strong>{`Please provide some contact details so we can create an account for you. `}</strong>
                    {`Once you have submitted this information, you will be taken to the payment screen.`}
                </>
            ),
            header: 'Create Your Account',
        },
    },
    CONTENT_CREATOR: {
        ...commonForm,
        form: {
            ...commonForm.form,
            data: [
                ...commonForm.form.data,
                {
                    name: 'type_of_business',
                    label: 'Type of Business',
                    type: 'select',
                    required: true,
                    options: [
                        { value: 'Collecting Society', text: 'Collecting Society' },
                        { value: 'Video Games', text: 'Video Games' },
                        { value: 'Record Label', text: 'Record Label' },
                        { value: 'Digital music service', text: 'Digital music service' },
                        { value: 'Podcast', text: 'Podcast' },
                        { value: 'Advertising Agency', text: 'Advertising Agency' },
                        { value: 'Record Label - Film/TV', text: 'Record Label - Film/TV' },
                        { value: 'Music Publisher - Film/TV', text: 'Music Publisher - Film/TV' },
                        { value: 'TV & Film - Other', text: 'TV & Film - Other' },
                        { value: 'Music Placement Company', text: 'Music Placement Company' },
                        { value: 'Music Library', text: 'Music Library' },
                        { value: 'Music Clearance Company', text: 'Music Clearance Company' },
                        { value: 'Movie Trailer House', text: 'Movie Trailer House' },
                        { value: 'Film/TV Music Department', text: 'Film/TV Music Department' },
                        { value: 'Music Supervisor', text: 'Music Supervisor' },
                        { value: 'Other', text: 'Other' },
                    ],
                    placeholder: 'Please select...',
                },
            ],
            terms_acceptance: true,
        },
    },
    DSP: {
        ...commonForm,
        form: {
            ...commonForm.form,
            data: [
                ...commonForm.form.data,
                {
                    name: 'dsp_type',
                    label: 'Company Type',
                    type: 'select',
                    required: true,
                    options: [
                        { value: 'Video', text: 'Video' },
                        { value: 'Fitness', text: 'Fitness' },
                        { value: 'Social Media', text: 'Social Media' },
                        { value: 'Gaming', text: 'Gaming' },
                        { value: 'Karaoke', text: 'Karaoke' },
                        { value: 'Music Streaming', text: 'Music Streaming' },
                        { value: 'Other', text: 'Other' },
                    ],
                    placeholder: 'Please select...',
                },
            ],
            terms_acceptance: true,
        },
        content: {
            ...commonForm.content,
            header: 'Create Your DSP Account',
        },
    },
};

export { PersonaEnum, PersonaData };
